import type { SelectContentProps, MultiSelectOption } from 'components/ui/Forms';

type OptionTypeBase = {
  [k: string]: any
}

export function optionsMapper(input: OptionTypeBase): SelectContentProps {
  return {
    name: input.label,
    value: input.value,
  };
}

export function multiSelectorOptionsMapper(input: OptionTypeBase): MultiSelectOption {
  return {
    label: input.label,
    value: input.value?.toString(),
  };
}